// @mui/icons-material
import Settings from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import Description from '@mui/icons-material/Description';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

export const routes = [
  {
    user: true,
    path: '/modifier-profil',
    name: 'Modifier mon profil',
    icon: Settings,
  },
  {
    path: '/annonces',
    name: 'Trouver un stage',
    icon: SearchIcon,
  },
  {
    path: '/messages',
    name: 'Mes messages',
    icon: InsertCommentIcon,
  },
  {
    path: '/candidatures',
    name: 'Mes candidatures',
    icon: Description,
  },
  {
    path: '/association',
    name: 'Mon association',
    icon: SupervisorAccountIcon,
  },
  {
    path: '/rapport',
    name: 'Mon rapport de stage',
    icon: Description,
  },
];
